import { SUPPLIERRFQTOTAL } from "constants/supplier";

export const createRFQTOTAL = (payload) => {
	return async (dispatch) => {
		dispatch({ type: SUPPLIERRFQTOTAL, payload: payload });
	};
};
